export abstract class ConfigLoader {
  // eslint-disable-next-line
  public abstract loadSettings(): any;
}

export class ConfigStaticLoader implements ConfigLoader {
  // eslint-disable-next-line
  constructor(private readonly providedSettings?: any) {}

  // eslint-disable-next-line
  public loadSettings(): any {
    return Promise.resolve(this.providedSettings);
  }
}
